// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__J6TaR","vLegacy":"SelectSecondary_vLegacy__15IQ4","error":"SelectSecondary_error__1lqC1","disabled":"SelectSecondary_disabled__o4EjR"};